import React from 'react'

const DataclipResultTableEmptyState = () => (
  <p className="f2 lh-title pa7 tc purple">
    This Dataclip returned no results.
  </p>
)

export default DataclipResultTableEmptyState
